<template>
  <div
    class="main-wrapper"
  >
    <v-breadcrumbs
      :items="breadcrumbs"
      divider=">"
      class="breadcrumbs"
    >
      <template
        #item="{ item }"
      >
        <v-breadcrumbs-item
          :class="getBreadcrumbItemClasses(item)"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <div
      class="main-content"
    >
      <v-container
        fluid
        class="v-container"
      >
        <v-row
          class="content-row"
        >
          <v-col
            class="d-flex justify-center"
          >
            <span
              class="request-status-title"
            >
              {{ $t('road-maintenance/aggregator.select_request_type') }}
            </span>
          </v-col>
        </v-row>

        <v-row
          class="content-row"
        >
          <v-col
            class="input-form-card hover"
            @click="onInputFormType('TEMPORARY_TRAFFIC_REGULATION')"
          >
            <v-img
              src="/img/icons/overview-status-card-icon.svg"
              width="48"
              height="48"
              class="card-icon"
            />
            {{ $t('road-maintenance/aggregator.input_form_type_1') }}
          </v-col>
          <v-col
            class="input-form-card hover"
            @click="onInputFormType('TEMPORARY_TRAFFIC_REGULATION_EXCAVATION')"
          >
            <v-img
              src="/img/icons/overview-status-card-icon.svg"
              width="48"
              height="48"
              class="card-icon"
            />
            {{ $t('road-maintenance/aggregator.input_form_type_2') }}
          </v-col>
        </v-row>

<!--        Table-->
        <v-row
          class="content-row"
        >
          <v-col
            class="table-col"
          >
            <div
              class="table-wrapper"
            >
              <table>
                <thead>
                <tr
                  style="height: 52px;"
                >
                  <th
                    style="width: 240px; background-color: #F3F4F6; border-top-left-radius: 16px; border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.type_of_road') }}
                  </th>
                  <th
                    style="width: 240px; background-color: #F3F4F6; border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.type_of_request') }}
                  </th>
                  <th
                    style="width: 240px; background-color: #F3F4F6; border-top-right-radius: 16px;"
                  >
                    {{ $t('road-maintenance/aggregator.responsible_for_processing') }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  style="border-bottom: 1px solid #D4D4D8;"
                >
                  <td
                    style="border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.first_class_roads') }}
                  </td>
                  <td
                    style="border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.regulation') }}
                  </td>
                  <td>
                    {{ $t('road-maintenance/aggregator.input_form_type_1') }}
                  </td>
                </tr>
                <tr
                  style="border-bottom: 1px solid #D4D4D8;"
                >
                  <td
                    style="border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.second_class_roads') }}
                  </td>
                  <td
                    style="border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.regulation_and_excavation') }}
                  </td>
                  <td>
                    {{ $t('road-maintenance/aggregator.input_form_type_2') }}
                  </td>
                </tr>
                <tr
                  style="border-bottom: 1px solid #D4D4D8;"
                >
                  <td
                    style="border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.first_and_second_class_roads') }}
                  </td>
                  <td
                    style="border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.regulation') }}
                  </td>
                  <td>
                    {{ $t('road-maintenance/aggregator.input_form_type_1') }}
                  </td>
                </tr>
                <tr>
                  <td
                    style="border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.first_and_second_class_roads') }}
                  </td>
                  <td
                    style="border-right: 1px solid #D4D4D8;"
                  >
                    {{ $t('road-maintenance/aggregator.regulation_and_excavation') }}
                  </td>
                  <td>
                    {{ $t('road-maintenance/aggregator.input_form_type_2') }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewRequestView',

  data () {
    return {
      breadcrumbs: [
        {
          text: this.$t('road-maintenance.aggregator')
        },
        {
          text: this.$t('road-maintenance.requests')
        },
        {
          text: this.$t('road-maintenance/aggregator.new_request_card_title'),
          bolded: true
        }
      ]
    }
  },

  methods: {
    getBreadcrumbItemClasses (item) {
      let classes = ''

      if (this.$vuetify.breakpoint.mobile) {
        classes += 'v-breadcrumb-item--mobile'
      }
      else {
        classes += 'v-breadcrumb-item'
      }

      if (item && item.bolded) {
        classes += ' v-breadcrumb-item--bolded'
      }

      return classes
    },

    onInputFormType (type) {
      this.$router.push({
        name: this.$route.name,
        query: {
          category: 'request_new',
          request_type: type
        }
      })
    }
  }
}
</script>

<style scoped>
.main-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #FFFFFF;
  margin: 0 24px 24px 15px;
  border-radius: 16px;
}

.main-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.breadcrumbs {
  padding: 14px 14px 14px 24px;
}

.v-breadcrumb-item {
  font-family: 'Satoshi', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #6B7280;
}

.v-breadcrumb-item--mobile {
  font-family: 'Satoshi', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #6B7280;
}

.v-breadcrumb-item--bolded {
  color: #111827;
}

.v-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.request-status-title {
  font-weight: 500;
  font-size: 32px;
  line-height: 40px;
  color: #09090B;
  text-align: center;
}

.content-row {
  justify-content: center;
  flex: unset;
}

::v-deep {
  .v-text-field--outlined fieldset {
    border-color: #E5E7EB !important;
    border-radius: 8px !important;
  }
}

.input-form-card {
  display: grid;
  max-width: 348px;
  height: 152px;
  padding: 24px;
  border: 1px solid #A1A1AA;
  border-radius: 20px;
  background-color: #FAFAFA;
  font-family: 'Satoshi', sans-serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  margin-right: 24px;
  align-content: center;
  text-align: center;
  color: #52525B;
}

.hover:hover {
  background-color: #EDF9FF;
  border: 1px solid #163D73;
  cursor: pointer;
}

.table-col {
  display: flex;
  justify-content: center;
}

table, th, td {
  border-collapse: collapse;
}

table td {
  text-align: center;
  height: 52px;
  font-family: 'Satoshi', sans-serif;
  color: #6B7280;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

table th {
  font-family: 'Satoshi', sans-serif;
  color: #111827;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.table-wrapper {
  border-radius: 16px !important;
  border: 1px solid #D4D4D8;
  margin-top: 24px;
  margin-left: -20px;
}

.card-icon {
  justify-self: center;
  margin-bottom: 10px;
}

@media (max-width:801px) {
  .content-row {
    min-width: 100%;
  }
}
</style>
